import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

export const Title = styled(Text)`
  margin-bottom: ${cssTheme.layout.spacing.s300};
  margin-left: ${cssTheme.layout.spacing.s500};
  margin-right: ${cssTheme.layout.spacing.s500};

  ${linariaMq.desktopXs} {
    margin-left: 0;
    margin-right: 0;
  }

  ${linariaMq.desktopMd} {
    margin-bottom: ${cssTheme.layout.spacing.s500};
  }
`
